/**
 * This file contains the code for creating or editing the quiz
 */

import React from "react";

export class SeoSettingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seoSettingInfo: [],
      quiz: "",
    };
    this.getSeoSeetingValue = this.getSeoSeetingValue.bind(this);
  }
  componentWillReceiveProps() {
    var getQuiz = this.props.quiz;
    // getQuiz.privacy_policy = getQuiz.privacy_policy;
    this.setState({
      quiz: getQuiz,
      selectedCheckboxes: getQuiz.privacy_policy
        ? JSON.parse(getQuiz.privacy_policy)
        : [],
    });
    this.getSeoSeetingValue = this.getSeoSeetingValue.bind(this);
  }
  getSeoSeetingValue(event) {
    var seoSettingInfo = this.state.seoSettingInfo;
    seoSettingInfo[event.target.name] = event.target.value;
    this.setState({
      seoSettingInfo: seoSettingInfo,
    });
    this.props.sendSeoSeetingData(this.state.seoSettingInfo);
  }

  render() {
    var content = null;
    content = (
      <div>
        <div className="form-group">
          <div className="Sign-In-Label">Meta Title</div>
          <input
            type="text"
            onChange={this.getSeoSeetingValue}
            className="Sign-In-TextBox"
            name="meta_title"
            value={this.props.quiz.meta_title}
            placeholder="Meta Title"
          />
        </div>
        <div className="form-group">
          <div className="Sign-In-Label">Meta Description </div>
          <textarea
            className="form-control Sign-In-TextBox"
            name="meta_description"
            onChange={this.getSeoSeetingValue}
            placeholder="Meta Description"
            id="txtqzque"
            rows="3"
            value={this.props.quiz.meta_description}
          ></textarea>
        </div>
        <div className="form-group">
          <div className="Sign-In-Label">Google Analytics</div>
          <textarea
            className="form-control Sign-In-TextBox"
            placeholder="UA-123456"
            name="google_analytics"
            onChange={this.getSeoSeetingValue}
            id="txtqzque"
            rows="3"
            value={this.props.quiz.google_analytics}
          ></textarea>
        </div>
        <div className="form-group">
          <div className=" Sign-In-Label">
            CRM tag (Please ensure crm settings are configured and tags are
            configured in CRM system)
          </div>
          <textarea
            className="crm_text_block form-control Sign-In-TextBox"
            placeholder="CRM Tag"
            name="crm_tag"
            onChange={this.getSeoSeetingValue}
            id="txtqzque"
            rows="3"
            value={this.props.quiz.crm_tag}
          ></textarea>
        </div>
      </div>
    );
    return content;
  }
}
